import BaseContainer from '@/components/BaseContainer';
import HeroCubeBg from '@/components/HeroCubeBg';
import AssetsHero from './AssetsHero';
import Downloads from './Downloads';
import { Box } from '@chakra-ui/react';
import Colors from './Colors';
import ColorTerms from './ColorTerms';
import CallToAction from '../HomeContainer/CallToAction';
import Reveal from '../HomeContainer/Reveal';
import { colors } from '@/styles/theme/colors';

type Component = {
  id: string;
  component: JSX.Element;
  bgColor: string;
  animate: boolean;
  container: boolean;
};

const components: Component[] = [
  {
    id: 'downloads',
    component: <Downloads />,
    bgColor: colors.diment.lightGrey,
    animate: true,
    container: true,
  },
  {
    id: 'colors',
    component: <Colors />,
    bgColor: 'white',
    animate: true,
    container: true,
  },
  {
    id: 'colorterms',
    component: <ColorTerms />,
    bgColor: colors.diment.lightGrey,
    animate: true,
    container: true,
  },
  {
    id: 'calltoaction',
    component: <CallToAction />,
    bgColor: 'white',
    animate: true,
    container: false,
  },
];

const AssetsContainer = () => {
  return (
    <>
      <HeroCubeBg>
        <BaseContainer>
          <AssetsHero />
        </BaseContainer>
      </HeroCubeBg>

      {components.map((item, index) => {
        return (
          <Box key={item.id} bgColor={item.bgColor} w='full' my={4}>
            {item.container ? (
              <BaseContainer>
                <Reveal animate={item.animate}>{item.component}</Reveal>
              </BaseContainer>
            ) : (
              <Reveal animate={item.animate}>{item.component}</Reveal>
            )}
          </Box>
        );
      })}
    </>
  );
};

export default AssetsContainer;
